import { Compass, Users, Database, Sparkles, Network, Download } from "lucide-react";
import { Reveal, MaskLines, Eyebrow } from "./motion";
import { EbookGate } from "./EbookGate";
import { useEffect, useState } from "react";

const spot = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
};

const Cell = ({ id, icon: Icon, title, text, className = "", children, delay }) => (
  <Reveal delay={delay} className={className}>
    <div onMouseMove={spot} data-testid={`pillar-${id}`} className="spot-card group relative flex h-full flex-col justify-between overflow-hidden rounded-[28px] border border-white/10 bg-navy-card p-7 sm:p-9">
      {children}
      <div className="relative flex items-center justify-between">
        <span className="grid h-12 w-12 place-items-center rounded-2xl bg-white/5 text-orange ring-1 ring-white/10 transition-[background-color,color] duration-500 group-hover:bg-orange group-hover:text-white">
          <Icon className="h-5 w-5" />
        </span>
      </div>
      <div className="relative mt-10">
        <h3 className="font-display text-2xl font-extrabold text-white sm:text-3xl">{title}</h3>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-300 sm:text-base">{text}</p>
      </div>
    </div>
  </Reveal>
);

export const Pillars = () => {
  const [ebook, setEbook] = useState(window.location.hash === "#ebook");
    useEffect(() => {
    if (window.location.hash === "#ebook") {
      setEbook(true);
    }
  }, []);
  return (
  <section id="metodo" className="grain relative bg-navy py-24 text-white sm:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Eyebrow dark num="03">O que realmente fazemos</Eyebrow>
          <h2 className="mt-6 font-display text-4xl font-black leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
            <MaskLines lines={["Não ajudamos apenas", "a abrir agências.", <span className="text-orange">Ajudamos a construir empresários.</span>]} />
          </h2>
        </div>
        <div className="lg:col-span-4 lg:col-start-9">
          <Reveal>
            <button id="ebook" onClick={() => setEbook(true)} data-testid="ebook-cta" className="group relative flex w-full items-center justify-between gap-6 overflow-hidden rounded-2xl bg-[#143061] px-8 py-9 text-left ring-2 ring-orange/60 shadow-[0_25px_90px_-20px_rgba(255,94,30,0.65)] transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-2 hover:shadow-[0_35px_100px_-15px_rgba(255,94,30,0.9)]">
              <span aria-hidden className="absolute inset-y-0 left-0 w-1.5 bg-orange" />
              <span>
                <span className="block font-display text-xl font-black leading-tight text-white sm:text-2xl">Como Abrir uma Agência Imobiliária Rentável em 2026</span>
                <span className="mt-2 block whitespace-nowrap font-bebas text-3xl tracking-wide text-orange sm:text-5xl">EBOOK GRATUITO</span>
              </span>
              <span className="grid h-20 w-20 shrink-0 place-items-center rounded-full bg-orange text-white transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
                <Download className="h-9 w-9" />
              </span>
            </button>
          </Reveal>
          <Reveal delay={0.1} className="mt-6 text-base leading-relaxed text-slate-300 sm:text-lg">
            Quando alguém entra na nossa rede não recebe apenas uma marca. Recebe:
          </Reveal>
        </div>
      </div>

      <div className="mt-16 grid auto-rows-[minmax(260px,auto)] gap-4 md:grid-cols-6" data-testid="pillars-bento">
        <Cell id="metodo" icon={Compass} title="Método" text="Mais de 24 anos de experiência transformados em processos." className="md:col-span-6 lg:col-span-4 lg:row-span-2" delay={0}>
          <img src="/img/pilar-metodo.webp" alt="Formação interna da equipa Soluções Ideais" className="absolute inset-0 h-full w-full object-cover opacity-25 transition-[opacity,transform] duration-700 group-hover:scale-105 group-hover:opacity-35" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-card via-navy-card/60 to-transparent" />
          <span aria-hidden className="text-outline-orange pointer-events-none absolute -top-6 right-4 font-display text-[11rem] font-black leading-none sm:text-[16rem] lg:text-[20rem]">24</span>
        </Cell>
        <Cell id="acompanhamento" icon={Users} title="Acompanhamento" text="Um diretor operacional experiente dedicado ao sucesso da abertura e do crescimento da unidade." className="md:col-span-3 lg:col-span-2" delay={0.08}>
          <img src="/img/pilar-acompanhamento.webp" alt="Reunião de acompanhamento Soluções Ideais" className="absolute inset-0 h-full w-full object-cover opacity-30 transition-[opacity,transform] duration-700 group-hover:scale-105 group-hover:opacity-45" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-card via-navy-card/70 to-transparent" />
        </Cell>
        <Cell id="tecnologia" icon={Database} title="Tecnologia" text="CRM próprio desenhado para o setor imobiliário." className="md:col-span-3 lg:col-span-2" delay={0.16}>
          <img src="/img/pilar-tecnologia.webp" alt="Trabalho no CRM da Soluções Ideais" className="absolute inset-0 h-full w-full object-cover opacity-30 transition-[opacity,transform] duration-700 group-hover:scale-105 group-hover:opacity-45" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-card via-navy-card/70 to-transparent" />
        </Cell>
        <Reveal delay={0.08} className="md:col-span-3 lg:row-span-2">
          <div data-testid="pillar-ia" className="spot-card group relative flex h-full flex-col overflow-hidden rounded-[28px] border border-white/10 bg-white/[0.06] p-6 sm:p-8">
            <span className="relative grid h-12 w-12 place-items-center rounded-2xl bg-white/5 text-orange ring-1 ring-white/10 transition-[background-color,color] duration-500 group-hover:bg-orange group-hover:text-white">
              <Sparkles className="h-5 w-5" />
            </span>
            <div className="relative mt-8">
              <h3 className="font-display text-2xl font-extrabold text-white sm:text-3xl">Inteligência Artificial</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-300 sm:text-base">Ferramentas desenvolvidas internamente para aumentar produtividade e resultados.</p>
            </div>
            <div className="relative mt-6 min-h-[280px] flex-1 overflow-hidden rounded-[20px] bg-white sm:p-2">
              <img src="/img/pilar-ia.jpg" alt="ERIC — inteligência artificial da Soluções Ideais: prospeção inteligente, estudos de mercado, ERIC Assistant, ERIC Legal e CRM com IA" className="h-full w-full object-cover object-center min-h-[264px] sm:min-h-0 sm:object-contain transition-transform duration-700 group-hover:scale-[1.03]" />
            </div>
          </div>
        </Reveal>
        <Cell id="comunidade" icon={Network} title="Comunidade" text="Uma rede de empresários que cresce junta." className="md:col-span-3 lg:row-span-2" delay={0.16}>
          <img src="/img/gala.webp" alt="Evento da rede Soluções Ideais — Gala de Reconhecimento" className="absolute inset-0 h-full w-full object-cover object-[58%_center] opacity-45 transition-[opacity,transform] duration-700 group-hover:scale-105 group-hover:opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-card via-navy-card/60 to-transparent" />
        </Cell>
      </div>
      <EbookGate open={ebook} onClose={() => setEbook(false)} />
    </div>
  </section>
  );
};
